<!--  -->
<template>
  <div>
    <div class="optionbox">
      <div class="optiontext">章节：</div>
      <el-input v-model="fromAge" type="number" style="width:400px" placeholder="请输入章节(只能输入1-8)" />
    </div>
    <div class="optionbox">
      <div class="optiontext">推广链接名称：</div>
      <el-input v-model="promotion_name" style="width:400px" placeholder="请输入推广链接名称(只能输入汉字、字母、数字和中划线)" :change="check_num()" />
    </div>
    <el-button type="primary" @click="sumbit">确定</el-button>
  </div>
</template>

<script>
import { bookPlatformcreate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      objquery: {},
      fromAge: '',
      promotion_name: ''
    }
  },
  watch: {
    fromAge(newName, oldName) {
      var reg = /^([1-9]\d|\d)$/
      if (!reg.test(newName)) {
        this.fromAge = ''
      } else {
        if (newName > 8) {
          this.fromAge = 8
        // eslint-disable-next-line eqeqeq
        } else if (newName == 0) {
          this.fromAge = 1
        } else {
          this.fromAge = newName
        }
      }
    },
    obj: {
      handler(newValue, oldValue) {
        // console.log('111', newValue)
        this.objquery = newValue
      },
      deep: true
    }
  },
  created() {
    this.objquery = this.obj
  },
  mounted() {

  },
  methods: {
    check_num: function() {
      this.promotion_name = this.promotion_name.replace(/[^\a-\z\A-\Z0-9\u4e00-\u9fe5-]/g, '')
    },
    async sumbit() {
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.fromAge === '') {
        this.$message.error('请输入章节')
        return
      }
      if (this.promotion_name === '') {
        this.$message.error('请输入推广链接名称')
        return
      }
      const data = await bookPlatformcreate({
        platform_id: this.objquery.platformvalue,
        template_data: {
          book_id: this.objquery.bookid,
          index: this.fromAge,
          promotion_name: this.promotion_name
        }
      })
      console.log('data', data)
      this.$emit('close')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
/* @import url(); 引入css类 */
.optionbox{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext{
  width: 100px;
  text-align: right;
}
.loltext{
  margin-left: 100px;
}
.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
